/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

const Dialog = require("@react/react-spectrum/Dialog").default;

class UnavailableQuickToolsFeature extends Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    return (
      <Dialog
        onClose={this.props.cancelDialog}
        title="Coming Soon"
        confirmLabel={formatMessage({ id: "common.ok" })}
        autoFocusButton="confirm"
      >
        <p>This feature is not yet available</p>
      </Dialog>
    );
  }
}

export { UnavailableQuickToolsFeature };
